export default class FilterOption {
  static empty () {
    return new FilterOption({
      key: '',
      name: '',
      isDisabled: false
    })
  }

  static fromJSON (json) {
    return new FilterOption({
      key: json.key,
      name: json.name,
      isDisabled: json.isDisabled
    })
  }

  constructor ({ key, name, isDisabled }) {
    this.key = key || ''
    this.name = name || ''
    this.isDisabled = isDisabled || false
  }

  clone () {
    return new FilterOption({
      ...this
    })
  }
}
